import { applyMiddleware, createStore, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { rootReducer } from './reducers';
import { createSentryEnhancer } from '@myua/sentry';
import { lm, rootListeners } from './listenerMiddleware';

const middlewares = [
  lm.listenerMiddleware.middleware,
  ...(import.meta.env.VITE_SHOW_LOGGER ? [createLogger()] : []),
];

const middlewareEnhancer = applyMiddleware(...middlewares);

const sentryEnhancer = createSentryEnhancer((state) => {
  const user = { ...(state?.app?.user ?? {}) };
  delete user.permissions;
  return { user };
});

const enhancers = compose(middlewareEnhancer, sentryEnhancer);

export const store = createStore(rootReducer, {}, enhancers);

rootListeners();
// NB: appActions.main() НЕ диспатчится здесь. Бутстрап (проверка авторизации →
// seed юзера → main → render) оркестрируется в index.tsx после того, как мы
// убедились, что пользователь залогинен. См. index.tsx.
